import React from 'react'

import MiscUtils from 'infra/MiscUtils'

import fiboLogo from 'resources/fibo_logo.png'
import fiboIcon from 'resources/fibo_icon.png'

export default class LoginHeader extends React.Component {

  render() {
    return (
      <div style={styles.container}>
        <div style={styles.image}>
          <img src={fiboIcon} alt="icon" width={60} height={60} style={{ marginRight: 22 }}/>
          <img src={fiboLogo} alt="logo" width={138} height={60} />
        </div>
      </div>
    )
  }

}

const styles = {

  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    backgroundColor: MiscUtils.STAGE === 'prod' ? '#527da3' : '#717171'
  },
  
  image: {
    marginTop: 22,
    marginBottom: 22
  }

}



// WEBPACK FOOTER //
// ./src/login/LoginHeader.js